import React, { Component } from 'react';
import { Modal, Button, FormCheck, FormLabel } from 'react-bootstrap';
import { getFromStorage } from '../../../utils/storage';
import moment from 'moment';

export default class ConfirmDialog extends Component {

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title style={{marginBottom: "-100px"}}>Message</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>Invoice Number: {getFromStorage("inv_num")}</div>
                    <div>Time of Trasaction: {moment(getFromStorage("pay_time"), "YYYY-MM-DDThh:mm:ss").format("hh:mm:ss a DD-MM-YYYY")}</div>
                    {
                        
                    }
                    {
                        this.props.status === "failure" ? 
                        <div style={{textAlign: "center"}}>
                            <img src={require("../../../image/error.png")} height="200px" width="200px"/>
                            <h4>Payment Failed</h4>
                        </div>
                        :
                        this.props.status === "cancel" ?
                        <div style={{textAlign: "center"}}>
                            <img src={require("../../../image/error.png")} height="200px" width="200px"/>
                            <h4>Payment Cancelled</h4>
                        </div>
                        : this.props.status === "success" ?
                        <div style={{textAlign: "center"}}>
                            <img src={require("../../../image/success.png")} height="200px" width="200px"/>
                            <h4>Payment Successful</h4>
                        </div>
                        :
                        <div style={{textAlign: "center"}}>
                            <img src={require("../../../image/error.png")} height="200px" width="200px"/>
                            <h4>Payment Failed</h4>
                            <p>{this.props.status}</p>
                        </div>
                    }
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={this.props.handleClose}>OK</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}